import Service from "../../Services";

const TravelInfo = {
  namespaced: true,
  state: {
    form: {
      id: "",
      branch_id: "",
      title_en: "",
      title_th: "",
      description_en: "",
      description_th: "",
      image: "",
      image_show: "",
      image_name: "",
      icon_active: "",
      icon_active_show: "",
      icon_inActive: "",
      icon_inActive_show: "",
      slug_url: "",
      download_url: "",
      download_url_show: "",
      is_publish: true
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        branch_id: "",
        title_en: "",
        title_th: "",
        description_en: "",
        description_th: "",
        image: "",
        image_show: "",
        image_name: "",
        icon_active: "",
        icon_active_show: "",
        icon_inActive: "",
        icon_inActive_show: "",
        slug_url: "",
        download_url: "",
        download_url_show: "",
        is_publish: true
      };
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getTravelInfo({ commit }, page) {
      return Service.TravelInfoAPI.getTravelInfo(page);
    },
    // eslint-disable-next-line no-unused-vars
    showTravelInfo({ commit }, id) {
      return Service.TravelInfoAPI.showTravelInfo(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveTravelInfo({ commit }, { id, data }) {
      if (id) {
        return Service.TravelInfoAPI.updateTravelInfo(id, data);
      } else {
        return Service.TravelInfoAPI.createTravelInfo(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteTravelInfo({ commit }, id) {
      return Service.TravelInfoAPI.deleteTravelInfo(id);
    },
    setFormTravelInfo({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    }
  }
};
export default TravelInfo;
